function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "children", "fileType", "singleFileMaxSize", "removeFn", "uploadFn", "beforeUploadFn", "onFailFn", "multiple", "onSuccessFn", "multiMaxNumber", "header", "showRetry", "initialFileList", "alertInfo", "fileMapKey", "verify", "listType"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Upload as AntdUpload, Image } from 'antd';
import classNames from 'classnames';
import { Alert, Button, Icon } from "./..";
import React, { useEffect, useState } from 'react';
import "./index.less";

// const { Dragger } = Upload;

var initTips = {
  maxSizeTip: '文件不能大于5MB',
  multiFileLengthTip: '文件总个数不能大于10个',
  deleteFailTip: '删除文件异常',
  typeTip: '文件类型需要符合Jpeg,Jpg,Gif,Png,tiff,PDF'
};

//用于预览文件时，读取File对象的数据
var getBase64 = function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      return resolve(reader.result);
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

//提示语
var AlertInfo = function AlertInfo(info) {
  Alert({
    period: 6,
    type: 'error',
    content: info,
    isToast: true
  });
};
var fileToFileObject = function fileToFileObject(fileListItem) {
  if ((fileListItem === null || fileListItem === void 0 ? void 0 : fileListItem.originFileObj) instanceof File) {
    return fileListItem === null || fileListItem === void 0 ? void 0 : fileListItem.originFileObj;
  }
  return fileListItem;
};
var defaultUpload = function defaultUpload(props) {
  var uploadText = props.uploadText;
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-upload-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-upload-default-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "tray-arrow-u",
    size: "medium"
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-upload-default-text"
  }, uploadText));
};
var IronUpload = function IronUpload(props) {
  //  处理props
  var className = props.className,
    children = props.children,
    fileType = props.fileType,
    singleFileMaxSize = props.singleFileMaxSize,
    removeFn = props.removeFn,
    uploadFn = props.uploadFn,
    beforeUploadFn = props.beforeUploadFn,
    onFailFn = props.onFailFn,
    multiple = props.multiple,
    onSuccessFn = props.onSuccessFn,
    multiMaxNumber = props.multiMaxNumber,
    header = props.header,
    showRetry = props.showRetry,
    initialFileList = props.initialFileList,
    alertInfo = props.alertInfo,
    fileMapKey = props.fileMapKey,
    verify = props.verify,
    listType = props.listType,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    fileList = _useState2[0],
    setFileList = _useState2[1];
  var allAlertInfo = _objectSpread(_objectSpread({}, initTips), alertInfo);
  var getFileList = function getFileList() {
    var resultList = [];
    if (initialFileList && initialFileList.length > 0) {
      resultList = _toConsumableArray(initialFileList);
      setFileList(_toConsumableArray(resultList));
    }
  };
  useEffect(function () {
    getFileList();
  }, [initialFileList]);

  //preview logic
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    previewOpen = _useState4[0],
    setPreviewOpen = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    previewImage = _useState6[0],
    setPreviewImage = _useState6[1];
  var handlePreview = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!file.url && !file.preview)) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return getBase64(file.originFileObj);
          case 3:
            file.preview = _context.sent;
          case 4:
            setPreviewImage(file.url || file.preview);
            setPreviewOpen(true);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handlePreview(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  //错误重试logic
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasError = _useState8[0],
    setHasError = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    uploading = _useState10[0],
    setUploading = _useState10[1];
  /**
   * 内置的验证方法
   * @param file
   * @param fileCount
   * @returns
   */
  var fileVerify = function fileVerify(file, fileCount) {
    var tempObj = file || {};
    if ((tempObj === null || tempObj === void 0 ? void 0 : tempObj.status) === 'removed') return true;
    if (verify) {
      var isAllowedType = fileType === null || fileType === void 0 ? void 0 : fileType.includes(file.type);
      if (!isAllowedType) {
        AlertInfo((allAlertInfo === null || allAlertInfo === void 0 ? void 0 : allAlertInfo.typeTip) || '');
        return false;
      } else if (Number(singleFileMaxSize) < file.size) {
        AlertInfo((allAlertInfo === null || allAlertInfo === void 0 ? void 0 : allAlertInfo.maxSizeTip) || '');
        return false;
      } else if (multiMaxNumber && fileCount > multiMaxNumber) {
        AlertInfo((allAlertInfo === null || allAlertInfo === void 0 ? void 0 : allAlertInfo.multiFileLengthTip) || '');
        return false;
      } else {
        return true; //验证通过，允许上传
      }
    } else {
      // 不使用内部校验规则，直接返回验证成功
      return true;
    }
  };

  /**
   * 上传中、完成、失败都会调用这个函数。
   * @param changeParam 文件状态改变的回调对象
   * @returns
   */
  var handleChange = function handleChange(changeParam) {
    if (!fileVerify(changeParam.file, changeParam.fileList.length)) {
      // 校验失败打算fileList 控制
      return;
    }
    var newFileList = changeParam.fileList;
    if (changeParam.file.status === 'done') {
      //标志文件的状态
      if (changeParam.file.response && changeParam.file.response.success === false) {
        changeParam.file.status = 'error';
        setHasError(true);
      }
      newFileList.forEach(function (item) {
        if (item.uid === changeParam.file.uid) {
          var _changeParam$file, _changeParam$file2, _changeParam$file4, _changeParam$file5, _changeParam$file6;
          //@ts-ignore
          var fileId = '';
          if (changeParam !== null && changeParam !== void 0 && (_changeParam$file = changeParam.file) !== null && _changeParam$file !== void 0 && (_changeParam$file = _changeParam$file.response) !== null && _changeParam$file !== void 0 && _changeParam$file.data && changeParam !== null && changeParam !== void 0 && (_changeParam$file2 = changeParam.file) !== null && _changeParam$file2 !== void 0 && (_changeParam$file2 = _changeParam$file2.response) !== null && _changeParam$file2 !== void 0 && _changeParam$file2.data[String(fileMapKey)]) {
            var _changeParam$file3;
            fileId = changeParam === null || changeParam === void 0 || (_changeParam$file3 = changeParam.file) === null || _changeParam$file3 === void 0 || (_changeParam$file3 = _changeParam$file3.response) === null || _changeParam$file3 === void 0 ? void 0 : _changeParam$file3.data[String(fileMapKey)];
          } else if (changeParam !== null && changeParam !== void 0 && (_changeParam$file4 = changeParam.file) !== null && _changeParam$file4 !== void 0 && (_changeParam$file4 = _changeParam$file4.response) !== null && _changeParam$file4 !== void 0 && _changeParam$file4.data && changeParam !== null && changeParam !== void 0 && (_changeParam$file5 = changeParam.file) !== null && _changeParam$file5 !== void 0 && (_changeParam$file5 = _changeParam$file5.response) !== null && _changeParam$file5 !== void 0 && (_changeParam$file5 = _changeParam$file5.data) !== null && _changeParam$file5 !== void 0 && _changeParam$file5[0] && changeParam !== null && changeParam !== void 0 && (_changeParam$file6 = changeParam.file) !== null && _changeParam$file6 !== void 0 && (_changeParam$file6 = _changeParam$file6.response) !== null && _changeParam$file6 !== void 0 && (_changeParam$file6 = _changeParam$file6.data) !== null && _changeParam$file6 !== void 0 && _changeParam$file6[0][String(fileMapKey)]) {
            var _changeParam$file7;
            fileId = changeParam === null || changeParam === void 0 || (_changeParam$file7 = changeParam.file) === null || _changeParam$file7 === void 0 || (_changeParam$file7 = _changeParam$file7.response) === null || _changeParam$file7 === void 0 || (_changeParam$file7 = _changeParam$file7.data) === null || _changeParam$file7 === void 0 ? void 0 : _changeParam$file7[0][String(fileMapKey)];
          }

          //加个返回的fileId用于删除文件，作唯一标识
          item[String(fileMapKey)] = fileId;
        }
      });
    } else {
      if (changeParam.file.status === 'error') {
        setHasError(true);
      }
    }
    setFileList(newFileList);
  };

  //自定义请求的函数 取代Upload原生的请求
  var uploadFile = function uploadFile(params) {
    var file = params.file,
      onSuccess = params.onSuccess,
      onError = params.onError,
      onProgress = params.onProgress;

    //调用传递进来的uploadFn
    var _uploadApi = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var files, onUploadProgress, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              files = _ref2.files, onUploadProgress = _ref2.onUploadProgress;
              if (!(uploadFn && uploadFn !== undefined)) {
                _context2.next = 6;
                break;
              }
              res = uploadFn(files, onUploadProgress);
              return _context2.abrupt("return", res);
            case 6:
              return _context2.abrupt("return", undefined);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function _uploadApi(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    _uploadApi({
      files: file,
      onUploadProgress: function onUploadProgress(_ref4) {
        var total = _ref4.total,
          loaded = _ref4.loaded;
        return onProgress({
          percent: Math.round(loaded / total * 100).toFixed(2)
        });
      }
    }).then(function (res) {
      if (res) {
        onSuccess(res);
        if (onSuccessFn) {
          onSuccessFn(params);
        }
      } else {
        onError();
        console.error('uploadFn 失败,调用上传接口失败,返回的res:', res);
        if (onFailFn) {
          onFailFn(res);
        }
      }
    }).catch(function (error) {
      onError();
      console.error('uploadFn error', error);
      if (onFailFn) {
        onFailFn(error);
      }
    });
  };

  //控制删除
  var handleRemove = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
      var tempArr, result;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            tempArr = fileList.filter(function (item) {
              return item.uid !== file.uid;
            });
            if (tempArr.length === 0) {
              // 都被删除之后，直接隐藏按钮
              setHasError(false);
            }
            result = false;
            if (!removeFn) {
              _context3.next = 10;
              break;
            }
            _context3.next = 7;
            return removeFn(file);
          case 7:
            result = _context3.sent;
            _context3.next = 11;
            break;
          case 10:
            // 没有实现删除方法则直接返回成功
            result = true;
          case 11:
            if (result === true) {
              setFileList(_toConsumableArray(tempArr));
            }
            return _context3.abrupt("return", result);
          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](0);
            console.error('upload handleRemove error:', _context3.t0);
            AlertInfo((allAlertInfo === null || allAlertInfo === void 0 ? void 0 : allAlertInfo.deleteFailTip) || '');
            return _context3.abrupt("return", false);
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 15]]);
    }));
    return function handleRemove(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  /**
   * 文件上传之前做校验
   * @param file
   * @param fileList
   * @returns
   */
  var beforeUpload = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file, currentFileList) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!beforeUploadFn) {
              _context4.next = 4;
              break;
            }
            _context4.next = 3;
            return beforeUploadFn(file, currentFileList);
          case 3:
            return _context4.abrupt("return", _context4.sent);
          case 4:
            return _context4.abrupt("return", fileVerify(file, fileList.length + currentFileList.length));
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function beforeUpload(_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }();

  //错误重试logic
  var handleRetry = function handleRetry() {
    /**
     * @param FileObject  传递给父组件的文件对象
     * @param file   已经上传的文件项 内部受控状态对象
     * @returns
     */
    var _upload = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(FileObject, file) {
        var res, _res$data, _res$data2, fileId, _res$data3;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(uploadFn && uploadFn !== undefined)) {
                _context5.next = 8;
                break;
              }
              _context5.next = 3;
              return uploadFn(FileObject);
            case 3:
              res = _context5.sent;
              if (res) {
                fileId = ''; //res?.data?.[0]?.fileId || res?.data?.fileId || '';
                if (res !== null && res !== void 0 && res.data && res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data[0] && res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2[0][String(fileMapKey)]) {
                  fileId = res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3[0][String(fileMapKey)];
                  file.status = 'done';
                  //加个返回的fileId用于删除文件，作唯一标识
                  file[String(fileMapKey)] = fileId;
                } else if (res !== null && res !== void 0 && res.data && res !== null && res !== void 0 && res.data[String(fileMapKey)]) {
                  fileId = res === null || res === void 0 ? void 0 : res.data[String(fileMapKey)];
                  file.status = 'done';
                  //加个返回的fileId用于删除文件，作唯一标识
                  file[String(fileMapKey)] = fileId;
                }
              }
              return _context5.abrupt("return", res);
            case 8:
              // 没有实现uploadFn 直接标记为上传文件错误
              file.status = 'error';
              return _context5.abrupt("return", undefined);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function _upload(_x6, _x7) {
        return _ref7.apply(this, arguments);
      };
    }();

    //选出上传失败的文件 用于重传
    var files = fileList.filter(function (file) {
      return file.status === 'error';
    });

    //包裹promise
    var promises = files.map(function (file) {
      return _upload(fileToFileObject(file), file);
    });
    //promise.all重试
    Promise.all(promises).then(function (results) {
      setUploading(false);
      var containsUndefined = results.some(function (element) {
        return element === undefined || element === 'undefined';
      });
      if (containsUndefined) {
        console.error('handleRetry 至少有一个请求失败:', results);
        if (onFailFn) {
          onFailFn(results);
        }
        //包含错误的结果
      } else {
        // 完全没有错误的项
        console.log('handleRetry 结果:', results);
        setHasError(false);
      }
    }).catch(function (error) {
      console.error('handleRetry 至少有一个请求失败:', error);
      setUploading(false);
      setHasError(true);
    });
  };
  var classes = classNames('iron-upload-wrapper', className, listType);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, header && /*#__PURE__*/React.createElement("div", {
    className: "iron-upload-header"
  }, header), /*#__PURE__*/React.createElement(AntdUpload, _extends({}, restProps, {
    //透传props
    listType: listType,
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChange,
    accept: fileType === null || fileType === void 0 ? void 0 : fileType.join(',')
    // 这个是用来替换action 的，和文件无关，只关乎接口请求
    ,
    customRequest: uploadFile,
    onRemove: handleRemove,
    multiple: multiple,
    beforeUpload: beforeUpload
  }), children ? children : defaultUpload(props)), previewImage && /*#__PURE__*/React.createElement("div", {
    className: "upload-image_wrapper"
  }, /*#__PURE__*/React.createElement(Image, {
    preview: {
      visible: previewOpen,
      onVisibleChange: function onVisibleChange(visible) {
        return setPreviewOpen(visible);
      },
      afterOpenChange: function afterOpenChange(visible) {
        return !visible && setPreviewImage('');
      }
    },
    src: previewImage
  })), /*#__PURE__*/React.createElement("div", null, showRetry && hasError && /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "arrow-round-2"
    }),
    onClick: handleRetry,
    disabled: uploading === true,
    style: {
      marginTop: 16
    }
  }, uploading ? 'Uploading' : 'Retry')));
};
IronUpload.defaultProps = {
  fileType: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'image/tiff'],
  multiple: false,
  header: '',
  singleFileMaxSize: 5 * 1024 * 1024,
  showRetry: false,
  initialFileList: [],
  multiMaxNumber: 10,
  fileMapKey: 'fileId',
  uploadText: 'Upload',
  verify: true,
  listType: 'picture-card'
};
export default IronUpload;